import { render, staticRenderFns } from "./create-estate.vue?vue&type=template&id=7b0e2fb4&scoped=true"
import script from "./create-estate.vue?vue&type=script&lang=js"
export * from "./create-estate.vue?vue&type=script&lang=js"
import style0 from "./create-estate.vue?vue&type=style&index=0&id=7b0e2fb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0e2fb4",
  null
  
)

export default component.exports